import { useCallback, useEffect, useState } from 'react';
export var useScrollBorders = () => {
  var [isBodyOverflowing, setIsBodyOverflowing] = useState(false);
  var [showBorderTop, setShowBorderTop] = useState(false);
  var [showBorderBottom, setShowBorderBottom] = useState(isBodyOverflowing);
  var ref = useCallback(el => {
    if (!el) return;
    setIsBodyOverflowing(el.scrollHeight > el.clientHeight);
  }, []);

  var onScroll = e => {
    var scrollAtTop = e.currentTarget.scrollTop === 0;
    var scrollAtBottom = e.currentTarget.scrollHeight - Math.ceil(e.currentTarget.scrollTop) === e.currentTarget.clientHeight;
    setShowBorderTop(!scrollAtTop); // show the top border as long as the scrollbar isn't at the top

    setShowBorderBottom(!scrollAtBottom); // show the bottom border as long as the scrollbar isn't at the bottom
  }; // This is for setting the border bottom when the modal opens


  useEffect(() => {
    setShowBorderBottom(isBodyOverflowing);
  }, [isBodyOverflowing]);
  return {
    showBorderTop,
    showBorderBottom,
    isBodyOverflowing,
    scrollProps: {
      ref,
      onScroll
    }
  };
};
//# sourceMappingURL=useScrollBorders.js.map